/* tslint:disable:max-line-length */
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './material/material';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from './auth-service/authService';
import { HttpService } from './http-service/http-service';
import { SlimLoadingBarModule } from 'ng2-slim-loading-bar';
import { CustomFormInputComponent } from './common/custom-form-input/custom-form-input.component';
import { DialogComponent } from './component/dialog/dialog.component';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { BaseComponent } from './component/protect-component/AdviserComponent/Subscriptions/subscription/common-subscription-component/base/base.component';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { CustomCommonModule } from './common/custom.common.module';
import { DatePipe, DecimalPipe } from '@angular/common';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
// import { SubscriptionModule } from './component/protect-component/AdviserComponent/Subscriptions/subscription.module';
import { EmailEntryModule } from './component/protect-component/AdviserComponent/Email/email.entry.module';
import 'zone.js/dist/zone';
// import { SubscriptionUpperEntry } from './component/protect-component/AdviserComponent/Subscriptions/subscription-upper-entry-module';
import { FormTestComponent } from './test/form-test/form-test.component';
import { CustomDirectiveModule } from './common/directives/common-directive.module';
import { BackofficeDashboardComponent } from './component/protect-component/AdviserComponent/backOffice/backoffice-dashboard/backoffice-dashboard.component';
// import { ScrollDispatchModule } from '@angular/cdk/scrolling';
// import { ServiceWorkerModule } from '@angular/service-worker';
import { ReferAndEarnPopupsComponent } from './component/no-protected/login/refer-and-earn-popups/refer-and-earn-popups.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
// import { AgmCoreModule } from '@agm/core'

// import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';


@NgModule({
  declarations: [
    AppComponent,
    // ConfirmDialogComponent,
    DialogComponent,
    CustomFormInputComponent,
    BaseComponent,
    // RadioGroupDirectiveDirective,

    // DialogContainerComponent,
    // CustomDialogContainerComponent,
    // AddLiabilitiesComponent,
    // AddInsuranceComponent
    FormTestComponent,
    BackofficeDashboardComponent,
    ReferAndEarnPopupsComponent,


  ],
  imports: [
    // CalendarModule,
    // SubscriptionEntry,
    // SubscriptionUpperEntry,
    NgxMaterialTimepickerModule,
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    MatCheckboxModule,
    MatExpansionModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MomentDateModule,
    MatSortModule,
    MatTableModule,
    SlimLoadingBarModule.forRoot(),
    MDBBootstrapModule.forRoot(),
    // CloudinaryModule.forRoot(Cloudinary,
    //   {
    //     cloud_name: 'futurewise', upload_preset: 'ifanow_unsigned_logo', /*private_cdn: true,*/
    //     /* cname: 'futurewise.images.com'*/
    //   }),
    DragDropModule,

    CustomCommonModule,
    EmailEntryModule,
    AppRoutingModule,
    CustomDirectiveModule,
    SlickCarouselModule,
    // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyADyxccMFAm_qzOE6slO2jHrKjQPlN_KG4',
    //   libraries: ['places']
    // })
    // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    // AssetsModule,

    // SubscriptionUpperEntry
  ],
  providers: [
    AuthService,
    HttpService,
    DatePipe,
    DecimalPipe
    // HttpCancelService,
    // { provide: HTTP_INTERCEPTORS, useClass: ManageHttpInterceptor, multi: true }
  ],

  bootstrap: [AppComponent],
  entryComponents: [ReferAndEarnPopupsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
  // entryComponents: [EntryComponentsModule.getComponentList(), AccountEntryModule.getComponentList(), PlanEntryModule.getComponentList()]
})
export class AppModule {
}
